import React, { useEffect, useState } from 'react';
import './SignIn.css';

const AuthCallback = ({ onSuccess, onError }) => {
  const [status, setStatus] = useState('processing');

  useEffect(() => {
    const handleCallback = () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('access_token');
        const email = urlParams.get('email');
        const error = urlParams.get('error');

        if (error) {
          setStatus('error');
          onError('Authentication failed. Please try again.');
          return;
        }

        if (token) {
          // Success - save token and notify parent
          localStorage.setItem('authToken', token);
          
          const userData = {
            email: email || 'user@example.com',
            name: email ? email.split('@')[0] : 'User',
          };

          localStorage.setItem('currentUser', JSON.stringify(userData));
          
          setStatus('success');
          
          // Clean up URL and redirect
          window.history.replaceState({}, document.title, window.location.pathname);
          
          setTimeout(() => {
            onSuccess(userData);
          }, 500);
        } else {
          setStatus('error');
          onError('No authentication token received.');
        }
      } catch (err) {
        console.error('Auth callback error:', err);
        setStatus('error');
        onError('An error occurred during authentication.');
      }
    };

    handleCallback();
  }, [onSuccess, onError]);

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-header">
          <div className="logo">
            <span className="logo-icon">🤖</span>
            <h1>Wolly Chat</h1>
          </div>
        </div>

        <div className="auth-callback-status">
          {status === 'processing' && (
            <>
              <div className="spinner"></div>
              <p>Completing sign in...</p>
            </>
          )}
          {status === 'success' && (
            <>
              <div className="success-icon">✓</div>
              <p>Sign in successful! Redirecting...</p>
            </>
          )}
          {status === 'error' && (
            <>
              <div className="error-icon">✕</div>
              <p>Authentication failed</p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthCallback;

